<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Ooops something went wrong</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">

  <div class="row mb-3">
    <div class="col-12">
      <h4>The page you requested could not be found.</h4>
      <p>If you came to this page from an external website then the link may have expired.</p>
      <p>This could be due to:</p>
      <ul>
        <li>a mistyped URL</li>
        <li>an out-of-date bookmark</li>
        <li>a search-engine listing for content that has moved or no longer exists</li>
        <li>a broken link on the website that we've missed</li>
      </ul>
    </div>
  </div>
</div>

